// Storage keys
export const USER_EMAIL_STORAGE_KEY = 'userEmail'
